import { FormButtonBase } from '@diagentech/exprworks-ui-components';
import { ButtonProps } from '@mui/material/Button';
import React from 'react';

import { I18nTypes } from '@/App/types';

interface DefaultFormButtonProps extends ButtonProps {
  id: I18nTypes;
}

export const DefaultFormButton: React.FC<DefaultFormButtonProps> = (props) => <FormButtonBase {...props} />;
